import { ApiFunc, getInstance, getNotAuthInstance } from '@helpers/httpClient'
import { dissoc, prop } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()

export const staff: ApiFunc<`${typeof API.STAFF_INFO}{id}`, 'get'> = data =>
  instance.get(`${API.STAFF_INFO}${'id' in data ? prop('id', data) : ''}`, {
    params: dissoc<Partial<Record<string, number | string>>, 'id'>('id', data),
  })

// export const staffCreate: ApiFunc<`${typeof API.STAFF}`, 'post'> = data => instance.post(API.STAFF, data)

export const staffDelete: ApiFunc<`${typeof API.STAFF}{id}`, 'delete'> = data =>
  instance.delete(`${API.STAFF}${'id' in data ? prop('id', data) : data?.name}`)

export const staffList: ApiFunc<`${typeof API.STAFF}`, 'get'> = data =>
  instance.get(API.STAFF, {
    params: data,
  })

export const staffAll: ApiFunc<`${typeof API.STAFF_ALL}`, 'get'> = data =>
  instance.get(API.STAFF_ALL, {
    params: data,
  })

export const staffAllFiltered: ApiFunc<`${typeof API.STAFF_ALL_FILTERED}`, 'get'> = data =>
  instance.get(API.STAFF_ALL_FILTERED, {
    params: data,
  })

export const staffPersonalInfoUpdate: ApiFunc<`${typeof API.STAFF_PERSONAL_INFO}`, 'put'> = data =>
  instance.put(API.STAFF_PERSONAL_INFO, data)

export const staffFullInfoUpdate: ApiFunc<`${typeof API.STAFF_FULL_INFO}`, 'put'> = data =>
  instance.put(API.STAFF_FULL_INFO, data)

export const staffHrInfoUpdate: ApiFunc<`${typeof API.STAFF_HR_INFO}`, 'put'> = data =>
  instance.put(API.STAFF_HR_INFO, data)

export const staffHrInfo: ApiFunc<`${typeof API.STAFF_HR_INFO}/{id}`, 'get'> = data =>
  instance.get(`${API.STAFF_HR_INFO}/${'id' in data ? prop('id', data) : ''}`, {
    params: dissoc<Partial<Record<string, number | string>>, 'id'>('id', data),
  })

export const staffFullInfo: ApiFunc<`${typeof API.STAFF_FULL_INFO}/{id}`, 'get'> = data =>
  instance.get(`${API.STAFF_FULL_INFO}/${'id' in data ? prop('id', data) : ''}`, {
    params: dissoc<Partial<Record<string, number | string>>, 'id'>('id', data),
  })

export const staffReference: ApiFunc<`${typeof API.STAFF_PROOF_OF_WORK_PDF}`, 'post'> = data =>
  instance.post(API.STAFF_PROOF_OF_WORK_PDF, data)

export const staffDepartmentPosition: ApiFunc<`${typeof API.STAFF_DEPARTMENT_POSITION}`, 'get'> = data =>
  instance.get(API.STAFF_DEPARTMENT_POSITION, {
    params: data,
  })

export const staffUsername: ApiFunc<`${typeof API.STAFF_USERNAME}{username}`, 'get'> = data =>
  instance.get(`${API.STAFF_USERNAME}${'username' in data ? prop('username', data) : data?.name}`, {
    params: 'username' in data ? dissoc('username', data) : dissoc('name', data),
  })

export const publicStaffRef: ApiFunc<`${typeof API.PUBLIC_STAFF_REF}`, 'get'> = data =>
  getNotAuthInstance().get(API.PUBLIC_STAFF_REF, { params: data })
